// import middle_east from "../../asset/middle-east.png";
import southeast from "../../asset/thailand-south-east.png";
import europe from "../../asset/europe.png";
// import northamerica from "../../asset/north-america.png"
const CountriesForImmersion = [
  {
    title: "Middle East",
    items: [
      "Large Indian community across countries like UAE, Saudi Arabia, Qatar.",
      "Indians working in construction, retail, IT, healthcare, and more.",
    ],
    path: "/immersion/middle-east",
  },
  {
    title: "South East Asia",
    items: [
      "Significant Indian population in countries like Singapore, Malaysia, Thailand.",
      "Indians in business, education, and tourism industries.",
    ],
    Image: southeast,
    path: "/immersion/southeast-asia",
  },
  {
    title: "Europe",
    items: [
      "Indian diaspora across UK, Germany, France, and more.",
      "Indians contributing to sectors like technology, healthcare, and academia.",
    ],
    Image: europe,
    path: "/immersion/europe",
  },
  // {
  //   title: "North America",                                                           // Required Later
  //   items: [
  //     "Canada and the US are home to large Indian populations.",
  //     "Indians working across various sectors like IT, healthcare, finance, and education.",
  //   ],
  //   Image: northamerica,
  //   path: "/immersion/north-america",
  // },
];

export default CountriesForImmersion;
